import { useEffect, useRef } from 'react';
import { Subject } from 'rxjs';

export interface EngineMessageSubjectEvent {
  type: string;
  payload: any;
}

export const EngineMessageSubject = new Subject<EngineMessageSubjectEvent>();

export function useOnEngineMessage(
  callback: (event: EngineMessageSubjectEvent) => void,
) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const subscription = EngineMessageSubject.subscribe((...args) =>
      callbackRef.current(...args),
    );
    return () => subscription.unsubscribe();
  }, []);
}
